import React from 'react';

function Onboarding() {
  return <div></div>;
}

export default Onboarding;
